import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import {
  SignedResourceResponse,
  UploadDAO,
} from '../../../../../../../core/services/dao/uploadDAO';
import { User } from 'anchor-shared/lib/model/entity/user';
import { UserDAO } from '../../../../../../../core/services/dao/userDAO';
import { NumberFormatterService } from '../../../../../../../core/services/number.formatter.service';
import { VesselDAO } from '../../../../../../../core/services/dao/vesselDAO';
import { ContainsSubscriptions } from '../../../../../../../core/services/interfaces/contains-subscriptions';
import { Subscription } from 'rxjs/Rx';
import { unsubscribeFromAll } from '../../../../../../../core/pure-functions/rx-helper';
import { AppMessagingService } from '../../../../../../../core/services/app-messaging.service';
import { Vessel } from 'anchor-shared/lib/model/entity/vessel';

@Component({
  selector: 'app-insurance-form',
  templateUrl: './insurance.component.html',
  styleUrls: ['./insurance.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class InsuranceFormComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  @Input() model: any;
  @Input() insuranceFiles: any[];
  @Input() disabled: boolean;

  priceMask: any;
  isAdmin = false;
  user: User;
  subs: Subscription[] = [];
  signedInsuranceUrl: string;
  insuranceModel: Partial<Vessel>;

  constructor(
    private uploadDAO: UploadDAO,
    private userDAO: UserDAO,
    private numberFormatterService: NumberFormatterService,
    private uploadDao: UploadDAO,
    private vesselDAO: VesselDAO,
    private appMessagingService: AppMessagingService,
  ) {
    this.priceMask = this.numberFormatterService.createPriceMask();
    this.user = this.userDAO.getCurrentUser();
    this.user.roles.map((role) => {
      if (role.adminAccess) {
        this.isAdmin = true;
      }
    });
  }

  ngOnInit() {
    if (this.model.insurancePhotoAbsPath) {
      this.vesselDAO
        .GetSignedUrlForVesselInsurance(
          this.model.id,
          this.model.insurancePhotoAbsPath,
        )
        .subscribe((signedUrl) => {
          this.signedInsuranceUrl = signedUrl.signedRequest;
        });
    }
  }

  ngOnDestroy() {
    unsubscribeFromAll(this.subs);
  }

  setModel(): void {
    this.insuranceModel = {
      id: this.model.id,
      cashValue: this.model.cashValue,
      hullId: this.model.hullId,
    };
  }

  uploadInsurance(event) {
    const file = event.target.files[0];
    const fileName = file.name;
    const fileUploadSub = this.uploadDao
      .uploadVesselInsurance(file, fileName)
      .subscribe((data) => {
        this.model.insurancePhotoAbsPath = data.relativePath;
        const vesselUpdateSub = this.vesselDAO
          .updateVesselInsurance(
            this.model.id,
            this.model.insurancePhotoAbsPath,
          )
          .subscribe((data) => {
            this.vesselDAO
              .GetSignedUrlForVesselInsurance(
                this.model.id,
                this.model.insurancePhotoAbsPath,
              )
              .subscribe((signedUrl) => {
                this.signedInsuranceUrl = signedUrl.signedRequest;
              });
            this.appMessagingService.openSnack('Vessel insurance uploaded!');
          });
        this.subs.push(vesselUpdateSub);
      });
    this.subs.push(fileUploadSub);
  }

  downloadProofOfInsurance() {
    window.open(this.signedInsuranceUrl);
  }
}
